// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__U5yE0","image":"styles_image__AO0nu","input":"styles_input__bqWPP","radioButton":"styles_radioButton__0jyhA","description":"styles_description__Z-oDr"};